import { prepareForSlot } from '@mui/base'
import { type FC } from 'react'

import { Link } from 'base-ui'

import { algoliaProxyRecordAccessorGetDeeplink } from '../../../algolia'
import { useExperimentCompositionApiTracking } from '../../../experiments/experiment-composition-api/useExperimentCompositionApiTracking'
import { NextLink } from '../../../next-link'
import { useWebviewContext } from '../../../webview'
import { useProductSearchContext } from '../../context/productSearchContextValue'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

const LinkSlot = prepareForSlot(NextLink)

export const ProductSearchResultItemTitle: FC = () => {
  const webview = useWebviewContext()

  const {
    algoliaRecord,
    onProductClick,
    query = '',
  } = useProductSearchResultItemContext()
  const { best_offer } = algoliaRecord

  const LinkComponent = webview ? 'a' : LinkSlot

  const trackCompositionApiExperiment = useExperimentCompositionApiTracking(
    best_offer?.seller?.id,
  )

  const { skipProductDeepLinkParams } = useProductSearchContext()
  const {
    __position: position,
    __queryID: queryID = '',
    offerId,
    productName,
  } = algoliaRecord

  const href = algoliaProxyRecordAccessorGetDeeplink({
    params: {
      eventName: 'click on product list item',
      offerId,
      position,
      query,
      queryID,
    },
    record: algoliaRecord,
    skipProductDeepLinkParams,
  })

  return (
    <Link
      className="block font-medium text-dark-primary-max no-underline hover:underline"
      color="inherit"
      data-qa-id="serp-result-item-title"
      href={href}
      onClick={() => {
        onProductClick?.()
        trackCompositionApiExperiment()
      }}
      overlay
      slots={{
        root: LinkComponent,
      }}
    >
      {productName}
    </Link>
  )
}
